import { RouteHandler } from '@whitetail/buckshot/scripts/buckshot-routes';
import $ from '@whitetail/buckshot/scripts/buckshot-dom';
import $mediator from '@whitetail/buckshot/scripts/buckshot-mediator';
import $events from '@whitetail/buckshot/scripts/buckshot-events';
import { _win } from '@whitetail/buckshot/scripts/core/variables';
import pushData from '../../scripts/dataLayer';

class CareerSearch {
    constructor() {
        this.$pathForm = $(':addCareerType');
        this.$stateForm = $(':addLocations');
        this.$search = $(':searchButton');
        this.paths = '';
        this.states = [];
        this.searchString = '';
    }

    init() {
        this.updateStates();
        this.search();
    }

    updateStates() {
        $mediator.on('state', (state, checked) => {
            if (!checked) {
                this.states = this.states.filter((option) => option !== state);
            } else {
                this.states.push(state);
            }
        });
    }

    search() {
        $events.on(this.$search, 'click', (e, el) => {
            const $button = $(el);
            const searchProp = $button.data('search');
            const searchParts = [];
            let dataLayer = '';

            if (searchProp === 'path') {
                const path = this.$pathForm.serialize(true)['career-path'];
                searchParts.push(`path=${path}`);
                dataLayer = `careertype=${path}`;
            } else {
                const states = this.states.join(',');
                searchParts.push(`location=${states}`);

                dataLayer = `state=${states}`;

                if ($button.data('path')) {
                    const path = $button.data('path');
                    searchParts.push(`path=${path}`);
                    dataLayer += `careertype=${path}`;
                }
            }

            pushData('career_search_submit', {
                search_filters: dataLayer,
            });

            this.searchString = searchParts.length ? '?' + searchParts.join('&') : '';

            _win.location.href = `${_win.location.origin}/careers/search${this.searchString}`;
        });
    }
}

export default new RouteHandler({
    init() {
        new CareerSearch().init();
    },
});
